module.exports = __webpack_public_path__ + "img/screen-theme.607ddf28.png";